<template>
  <el-form label-width="100px" ref="form" :hide-required-asterisk="disabled">
    <template v-for="(item, index) in cookingStepList">
      <step-item
          :key="index"
          :index="index"
          v-model="cookingStepList[index]"
          :disabled="disabled"
          @delStep="handleRemoveStep(index)"
          @syncPhoto="handleSyncPhoto"
          @add="handleAddStepByIndex(index)"
          :rotate-direction="rotateDirection"
          :work-model-list="workModelList"/>
    </template>

    <div style="width: 1000px">
      <div class="btn-box">
        <el-button @click="$router.back()" v-if="disabled">{{ $t('lang.返回') }}</el-button>
        <template v-else>
          <el-button @click="$emit('save')">{{ $t('lang.保存') }}</el-button>
          <el-button v-if="$store.getters.hasTranslate" @click="$emit('translate')">{{$t('lang.翻译')}}</el-button>
        </template>
        <el-button type="primary" @click="$emit('lastStep')">{{ $t('lang.上一步') }}</el-button>
        <el-button type="primary" @click="handleNext('next')">{{ $t('lang.下一步') }}</el-button>
      </div>
    </div>

  </el-form>
</template>

<script>
import {loadDict} from "../../js/common";
import {getTemplate} from "./utils";
import StepItem from "./StepItem";

export default {
  name: "RecipeCookingSteps",
  components: {StepItem},
  props: {
    status: {
      type: String,
      default: 'add'
    }
  },
  data() {
    return {
      cookingStepList: [],
      workModelList: [],
      disabled: false,
      rotateDirection: []
    }
  },
  computed: {
    supportLangList() {
      return this.$store.state.recipe.supportLangList;
    },
    lang() {
      return this.$store.state.recipe.lang;
    }
  },
  watch: {
    "cookingStepList": {
      handler(list) {
        this.$store.commit("CHANGE_RECIPE", {cookingStepList: list})
      },
      immediate: false,
      deep: true,
    },
    status: {
      handler(state) {
        if (state == 'detail') {
          this.disabled = true;
        }
      },
      immediate: true,
      deep: true,
    }
  },
  deactivated() {
    // console.log('除非')
    this.handleAutoIntroduction();
  },
  methods: {
    // 同步
    handleSyncPhoto(step) {
      step.photoVideoFileType = this.cookingStepList[0].photoVideoFileType;
      step.photoVideoFileCode = this.cookingStepList[0].photoVideoFileCode;
    },

    // 更新数据
    handleGetData() {
      this.$forceUpdate();
      let cookingStepList = this.$store.state.recipe.cookingStepList;
      if(!cookingStepList.length) this.cookingStepList = [];

      if (cookingStepList && cookingStepList.length) {
        console.log('cookingStepList', cookingStepList)
        this.cookingStepList = cookingStepList.map(item => {
          if(typeof item.autoStart === "string") {
            item.autoStart = item.autoStart === "true" ? true : false;
          }
          return item;
        });
      } else {
        let step = this.handleAddStep();
        this.cookingStepList.push(step);
      }

      console.log("步骤列表", this.cookingStepList)
    },

    // 删除step
    handleRemoveStep(index) {
      this.cookingStepList.splice(index, 1);
    },

    // 下一步需判断是否自动生成简介
    handleNext() {
      // this.handleAutoIntroduction();
      this.$emit("next");
    },

    // 按步骤自动生成简介
    handleAutoIntroduction()  {
      let {recipeLang, autoCreateStepDesc, type} = this.$store.state.recipe;
      if(!autoCreateStepDesc || autoCreateStepDesc === "0") return;

      // 获取所有步骤描述
      let stepDesc = this.cookingStepList.map(item => {
        let desc = []
        for (const lang in item.stepLang) {
          let text = item.number + "：";
          // 如果该语言描述有填写直接使用
          if(item.stepLang[lang]) {
            text += item.stepLang[lang];
          } else {
            // 使用模板
            text += getTemplate(type, item);
          }
          desc.push({lang, text})
        }
        return desc;
      })


      // 拼接所有步骤的描述
      let desc = new Map();
      stepDesc.forEach(item => {
        item.forEach(l => {
          if(!desc.has(l.lang)) desc.set(l.lang, "");
          desc.set(l.lang,  desc.get(l.lang) + l.text + "\n");
        })
      })

      // 设置并保存数据
      for (const lang in recipeLang) {
        recipeLang[lang].introduction = desc.get(lang) || "";
      }
      this.$store.commit("CHANGE_RECIPE", {recipeLang});
    },

    // 添加步骤
    handleAddStepByIndex(index) {
      let step = this.handleAddStep();
      this.cookingStepList.splice(index + 1, 0, step);
      this.cookingStepList.forEach((i, index) => i.number = (index + 1)  + "");
    },

    handleAddStep() {
      let step = {
        number: (this.cookingStepList.length + 1)  + "",
        workMode: '', // 模式
        stepLang: {}, // 描述文字
        photoVideoFileCode: '', // 图片/视频
        photoVideoFileType: '', //图片/视频类型
        audioFileCode: '', // 音频
        makeMode: '', // 制作模式
        autoStart: true, // 自动开始
        temperature: '', // 温度
        rotateDirection: '', // 旋转方向
        rotateSpeed: '', // 旋转速度
        minute: '', // 分钟
        second: '', // 秒
      };

      this.supportLangList.forEach(item => {
        step.stepLang[item] = '';
      })
      return step;
    },
  },
  async created() {
    this.workModelList = await loadDict(this, 'WORK_MODE');
    this.rotateDirection = await loadDict(this, 'ROTATE_DIRECTION');
    this.$bus.$on("translateRecipe", () => {
      this.handleGetData();
    });
  },
  activated() {
    this.$nextTick(() => {
      this.handleGetData();
    })
  },
}
</script>

<style scoped>

.input-icon {
  font-size: 26px;
  color: red;
}

.form-box-item {
  width: 1000px;
  background: #fcfcfc;
  border: 1px solid #dddddd;
  padding: 12px;
  margin-bottom: 24px;
  box-sizing: border-box;

}

.btn-box {
  width: 1000px;
  display: flex;
  justify-content: center;
  margin-top: 24px;
}

.media-row {
  display: flex;
  flex-direction: column;
  background: #eeeeee;
  border-radius: 10px;
  width: 320px;
  align-items: flex-end;
  box-sizing: border-box;
  padding: 6px;
}

.media-row .input-icon {
  margin-bottom: 6px;
}

/deep/ input::-webkit-outer-spin-button,
/deep/ input::-webkit-inner-spin-button {
  -webkit-appearance: none !important;
}

/deep/ input[type='number'] {
  -moz-appearance: textfield !important;
}

</style>
